"use strict";

var eventCollector = require('@finn-no/analytics');
var pulse = require('@finn-no/pulse-sdk');
var _require = require('./DataContext'),
  getDataContext = _require.getDataContext;
var _require2 = require('./constants'),
  AD_TYPE_KFS = _require2.AD_TYPE_KFS,
  AD_TYPE_PTS = _require2.AD_TYPE_PTS,
  AD_TYPE_PTS_UNIT = _require2.AD_TYPE_PTS_UNIT,
  AD_TYPE_ETS = _require2.AD_TYPE_ETS;
var _require3 = require('./trackingConstants'),
  TRACKING_ID_KFS = _require3.TRACKING_ID_KFS,
  TRACKING_ID_PTS = _require3.TRACKING_ID_PTS,
  TRACKING_ID_ETS = _require3.TRACKING_ID_ETS,
  ACTION_CLICK_PROSPECTUS_URL = _require3.ACTION_CLICK_PROSPECTUS_URL,
  ACTION_CLICK_PROJECT_URL = _require3.ACTION_CLICK_PROJECT_URL;
var adData = getDataContext('ad-data');
var adminData = getDataContext('admin-data');

/* 
    PULSE
    PageView events 
*/

function setGenericContext() {
  pulse.setState({
    vertical: {
      name: 'realestate',
      subVertical: 'new_buildings'
    }
  });
}

// RE_pv04 - Page view of new building object pages

function trackPageViewObject() {
  var adType = adData.adType,
    finnkode = adData.finnkode;
  setGenericContext();
  pulse.trackPageView({
    object: {
      type: 'ClassifiedAd',
      contentId: "".concat(finnkode),
      category: getCategory(adType),
      hasExtendedProfile: true
    }
  });
}

// RE_pv06 - Page view of ad admin new buildings

function trackPageViewAdminIndex() {
  setGenericContext();
  pulse.trackPageView({
    object: {
      type: 'Listing'
    }
  });
}

// RE_pv07 - Page view of ad detail - new buildings

function trackPageViewAdminAdDetail() {
  setGenericContext();
  pulse.trackPageView({
    object: {
      type: 'UserProfilePage',
      pageType: 'ad_detail'
    }
  });
}

// RE_pv05 - Page view nybygg admin page - buy marketing

function trackPageViewAdminBuyMarketing() {
  setGenericContext();
  pulse.trackPageView({
    object: {
      type: 'UserProfilePage',
      pageType: 'ad_admin'
    }
  });
}

// RE_pv08 - View ad selection page

function trackPageViewAdminAdSelect() {
  setGenericContext();
  pulse.trackPageView({
    object: {
      type: 'Page',
      pageType: 'ad_insertion'
    }
  });
}

// RE_pv09 - Page view of ad insersion form, step 1

function trackPageViewAdminAdForm() {
  var finnkode = adminData.finnkode;
  setGenericContext();
  pulse.trackPageView({
    name: 'Ad insertion - new building ad',
    object: {
      type: 'Form',
      formStepName: 'Ad input',
      formStepNumber: '1',
      formAction: 'Create classifiedAd',
      items: [{
        type: 'ClassifiedAd',
        id: "".concat(finnkode),
        contentId: "".concat(finnkode),
        name: 'n/a',
        category: 'n/a',
        hasExtendedProfile: true
      }]
    }
  });
}

// RE_pv10 - Page view of ad insersion form, step 2

function trackPageViewAdminAdPurchase() {
  var adType = adminData.adType,
    finnkode = adminData.finnkode;
  setGenericContext();
  pulse.trackPageView({
    name: 'Ad insertion - new building ad',
    object: {
      type: 'Form',
      formStepName: 'Buy product',
      formStepNumber: '2',
      formAction: 'Create classifiedAd',
      items: [{
        type: 'ClassifiedAd',
        id: "".concat(finnkode),
        contentId: "".concat(finnkode),
        name: 'n/a',
        category: getCategory(adType),
        hasExtendedProfile: true
      }]
    }
  });
}

// RE_pv11 - Page view of ad insersion form, receipt

function trackPageViewAdminAdConfirmation() {
  var adType = adminData.adType,
    finnkode = adminData.finnkode;
  setGenericContext();
  pulse.trackPageView({
    name: 'Ad insertion - new building ad',
    object: {
      type: 'Confirmation',
      items: [{
        type: 'ClassifiedAd',
        id: "".concat(finnkode),
        contentId: "".concat(finnkode),
        name: 'n/a',
        category: getCategory(adType),
        hasExtendedProfile: true
      }]
    }
  });
}

// RE_pv12 - Page view of price list

function trackPageViewAdminPriceOverview() {
  setGenericContext();
  pulse.trackPageView({
    object: {
      type: 'Page',
      pageType: 'product_description'
    }
  });
}

// RE_pv13 - Page view of edit org profile

function trackPageViewAdminOrgProfile() {
  setGenericContext();
  pulse.trackPageView({
    object: {
      type: 'UserProfilePage',
      pageType: 'tool'
    }
  });
}

/* 
    PULSE
    Action events, like Click, Open, Edit, etc. 
*/

// RE_ev04 - Register for viewing

function trackRegisterForViewing() {
  var projectName = adData.projectName,
    adType = adData.adType,
    finnkode = adData.finnkode,
    master = adData.master;
  pulse.trackEvent({
    type: 'Click',
    intent: 'Open',
    name: 'Register for Viewing',
    object: {
      id: "".concat(finnkode),
      type: 'UIElement',
      elementType: 'Link',
      position: 'Sidebar',
      items: [{
        type: 'ClassifiedAd',
        id: "".concat(finnkode),
        contentId: "".concat(finnkode),
        name: projectName || master.projectName,
        category: getCategory(adType),
        hasExtendedProfile: true
      }]
    },
    target: {
      id: "".concat(finnkode),
      type: 'ExternalContent',
      name: 'Go to webpage',
      referralCommission: false
    }
  });
}

// RE_ev10 - Sign up on interest list

function trackEventSignupInterestOpen() {
  var projectName = adData.projectName,
    adType = adData.adType,
    finnkode = adData.finnkode;
  pulse.trackEvent({
    type: 'Click',
    intent: 'Register',
    name: 'Sign up interest list',
    object: {
      id: "".concat(finnkode),
      type: 'UIElement',
      elementType: 'Button',
      items: [{
        type: 'ClassifiedAd',
        id: "".concat(finnkode),
        contentId: "".concat(finnkode),
        name: projectName,
        category: getCategory(adType),
        hasExtendedProfile: true
      }]
    }
  });
}

// RE_ev11 - Send sign up on interest list

function trackEventSignupInterestSend() {
  var projectName = adData.projectName,
    adType = adData.adType,
    finnkode = adData.finnkode;
  pulse.trackEvent({
    type: 'Click',
    intent: 'Save',
    name: 'Sign up interest list',
    object: {
      id: "".concat(finnkode),
      type: 'UIElement',
      elementType: 'Button',
      items: [{
        type: 'ClassifiedAd',
        id: "".concat(finnkode),
        contentId: "".concat(finnkode),
        name: projectName,
        category: getCategory(adType),
        hasExtendedProfile: true
      }]
    }
  });
}

// RE_ev33 - Click on "360 visning" on realestate ads

function trackClickOnVirtualViewingUrl() {
  var projectName = adData.projectName,
    adType = adData.adType,
    finnkode = adData.finnkode;
  pulse.trackEvent({
    type: 'Click',
    intent: 'View',
    name: '360 viewing',
    object: {
      id: "".concat(finnkode),
      type: 'UIElement',
      elementType: 'Icon',
      items: [{
        type: 'ClassifiedAd',
        id: "".concat(finnkode),
        contentId: "".concat(finnkode),
        name: projectName,
        category: getCategory(adType),
        hasExtendedProfile: true
      }]
    }
  });
}

// RE_ev33 - Click on "video visning" on realestate ads

function trackClickOnVideoViewingUrl() {
  var projectName = adData.projectName,
    adType = adData.adType,
    finnkode = adData.finnkode;
  pulse.trackEvent({
    type: 'Click',
    intent: 'View',
    name: 'Video viewing',
    object: {
      id: "".concat(finnkode),
      type: 'UIElement',
      elementType: 'Icon',
      items: [{
        type: 'ClassifiedAd',
        id: "".concat(finnkode),
        contentId: "".concat(finnkode),
        name: projectName,
        category: getCategory(adType),
        hasExtendedProfile: true
      }]
    }
  });
}

// RE_ev44 - Click on links in Nyttige linker

function trackClickOnLinksInUsefulLinks(position) {
  var finnkode = adData.finnkode,
    master = adData.master,
    projectName = adData.projectName,
    adType = adData.adType,
    brokers = adData.brokers,
    contactName = adData.contactName;
  var provider;
  if (master && master.brokers) {
    provider = master.brokers[0].contactName;
  } else if (brokers) {
    provider = brokers[0].contactName;
  } else {
    provider = contactName;
  }
  pulse.trackEvent({
    type: 'Click',
    intent: 'Open',
    name: 'Click ad useful link',
    object: {
      id: "".concat(finnkode),
      type: 'UIElement',
      elementType: 'Link',
      position: position,
      items: [{
        type: 'ClassifiedAd',
        id: "".concat(finnkode),
        contentId: "".concat(finnkode),
        name: projectName || master.projectName,
        category: getCategory(adType),
        hasExtendedProfile: true
      }]
    },
    target: {
      id: "".concat(finnkode),
      type: 'ExternalContent',
      name: 'Go to webpage',
      referralCommission: false,
      provider: provider
    }
  });
}

// CE_ev14 - Extended profile: Click on links (non uniqe tracking events)

function trackClickOnExtendedProfileLink(index) {
  var finnkode = adData.finnkode,
    master = adData.master,
    projectName = adData.projectName,
    adType = adData.adType,
    brokers = adData.brokers,
    contactName = adData.contactName;
  var provider;
  if (master && master.brokers) {
    provider = master.brokers[0].contactName;
  } else if (brokers) {
    provider = brokers[0].contactName;
  } else {
    provider = contactName;
  }
  pulse.trackEvent({
    type: 'Click',
    intent: 'Open',
    name: 'Extended profile link',
    object: {
      id: "".concat(finnkode),
      type: 'UIElement',
      elementType: 'Link',
      name: "Link: ".concat(index + 1),
      items: [{
        type: 'ClassifiedAd',
        id: "".concat(finnkode),
        contentId: "".concat(finnkode),
        name: projectName || master.projectName,
        category: getCategory(adType),
        hasExtendedProfile: true
      }]
    },
    target: {
      id: "".concat(finnkode),
      type: 'ExternalContent',
      name: 'Go to webpage',
      referralCommission: false,
      provider: provider
    }
  });
}

// CE_ev33 - Click on main CTA extended profile

function trackClickOnExtendedProfileCta() {
  var finnkode = adData.finnkode,
    master = adData.master,
    projectName = adData.projectName,
    adType = adData.adType,
    brokers = adData.brokers,
    contactName = adData.contactName;
  var provider;
  if (master && master.brokers) {
    provider = master.brokers[0].contactName;
  } else if (brokers) {
    provider = brokers[0].contactName;
  } else {
    provider = contactName;
  }
  pulse.trackEvent({
    type: 'Click',
    intent: 'Open',
    name: 'Extended profile action link',
    object: {
      id: "".concat(finnkode),
      type: 'UIElement',
      elementType: 'Button',
      items: [{
        type: 'ClassifiedAd',
        id: "".concat(finnkode),
        contentId: "".concat(finnkode),
        name: projectName || master.projectName,
        category: getCategory(adType),
        hasExtendedProfile: true
      }]
    },
    target: {
      id: "".concat(finnkode),
      type: 'ExternalContent',
      name: 'Go to webpage',
      referralCommission: false,
      provider: provider
    }
  });
}

// RE_ev47 - Go to homepage

function trackGoToHomepage() {
  var finnkode = adData.finnkode,
    master = adData.master,
    projectName = adData.projectName,
    adType = adData.adType,
    brokers = adData.brokers,
    contactName = adData.contactName;
  var provider;
  if (master && master.brokers) {
    provider = master.brokers[0].contactName;
  } else if (brokers) {
    provider = brokers[0].contactName;
  } else {
    provider = contactName;
  }
  pulse.trackEvent({
    type: 'Click',
    intent: 'Open',
    name: 'Go to homepage',
    object: {
      id: "".concat(finnkode),
      type: 'UIElement',
      elementType: 'Link',
      items: [{
        type: 'ClassifiedAd',
        id: "".concat(finnkode),
        contentId: "".concat(finnkode),
        name: projectName || master.projectName,
        category: getCategory(adType),
        hasExtendedProfile: true
      }]
    },
    target: {
      id: "".concat(finnkode),
      type: 'Page',
      name: 'Go to webpage',
      referralCommission: false,
      provider: provider
    }
  });
}

// RE_ev48 - Click on "contact by phone" in Meld interesse - nybygg

function trackPhoneNumberUserInterest() {
  var finnkode = adData.finnkode,
    master = adData.master,
    projectName = adData.projectName,
    adType = adData.adType;
  pulse.trackEvent({
    type: 'Click',
    intent: 'Register',
    name: 'Contact me by phone',
    object: {
      id: "".concat(finnkode),
      type: 'UIElement',
      elementType: 'Check box',
      position: 'Interest list signup',
      items: [{
        type: 'ClassifiedAd',
        id: "".concat(finnkode),
        contentId: "".concat(finnkode),
        name: projectName || master.projectName,
        category: getCategory(adType),
        hasExtendedProfile: true
      }]
    }
  });
}

// RE_ev29 - Click on unique customer content new building ads

function trackEventViewCustomerContent() {
  var finnkode = adData.finnkode,
    contactName = adData.contactName,
    brokers = adData.brokers,
    master = adData.master,
    projectName = adData.projectName,
    adType = adData.adType;
  var provider;
  if (master && master.brokers) {
    provider = master.brokers[0].contactName;
  } else if (brokers) {
    provider = brokers[0].contactName;
  } else {
    provider = contactName;
  }
  pulse.trackEvent({
    type: 'Click',
    intent: 'Open',
    name: 'Customer content clicked',
    object: {
      id: "".concat(finnkode),
      type: 'UIElement',
      elementType: 'Link',
      items: [{
        type: 'ClassifiedAd',
        id: "".concat(finnkode),
        contentId: "".concat(finnkode),
        name: projectName || master.projectName,
        category: getCategory(adType),
        hasExtendedProfile: true
      }]
    },
    target: {
      id: "".concat(finnkode),
      type: 'ExternalContent',
      name: 'Go to webpage',
      referralCommission: false,
      provider: provider
    }
  });
}

// RE_ev02 - Order complete listing

function trackEventOrderProspect() {
  var projectName = adData.projectName,
    adType = adData.adType,
    finnkode = adData.finnkode,
    master = adData.master;
  pulse.trackEvent({
    type: 'Click',
    intent: 'Open',
    name: 'Order prospect',
    object: {
      id: "".concat(finnkode),
      type: 'UIElement',
      elementType: 'Link',
      items: [{
        type: 'ClassifiedAd',
        id: "".concat(finnkode),
        contentId: "".concat(finnkode),
        name: projectName || master.projectName,
        category: getCategory(adType),
        hasExtendedProfile: true
      }]
    }
  });
}

// RE_ev12 - buy blink from new bulding marketing page - start

function trackEventBuyBlinkFromMarketingOpen() {
  var adType = adminData.adType,
    finnkode = adminData.finnkode;
  pulse.trackEvent({
    type: 'Click',
    intent: 'Open',
    name: 'Purchase blink',
    object: {
      id: "".concat(finnkode),
      type: 'UIElement',
      elementType: 'Button',
      items: [{
        type: 'ClassifiedAd',
        id: "".concat(finnkode),
        contentId: "".concat(finnkode),
        name: 'n/a',
        category: getCategory(adType),
        hasExtendedProfile: true
      }]
    }
  });
}

// RE_ev13 - buy blink from new buling marketing page - confirm

function trackEventBuyBlinkFromMarketingSend() {
  var adType = adminData.adType,
    finnkode = adminData.finnkode;
  pulse.trackEvent({
    type: 'Click',
    intent: 'Purchase',
    name: 'Purchase blink',
    object: {
      id: "".concat(finnkode),
      type: 'UIElement',
      elementType: 'Button',
      items: [{
        type: 'ClassifiedAd',
        id: "".concat(finnkode),
        contentId: "".concat(finnkode),
        name: 'n/a',
        category: getCategory(adType),
        hasExtendedProfile: true
      }]
    }
  });
}

// RE_ev14 - Click on see ad, ad detail

function trackEventViewAd() {
  var adType = adminData.adType,
    finnkode = adminData.finnkode;
  pulse.trackEvent({
    type: 'Click',
    intent: 'Open',
    name: 'View ad',
    object: {
      id: "".concat(finnkode),
      type: 'UIElement',
      elementType: 'Button',
      items: [{
        type: 'ClassifiedAd',
        id: "".concat(finnkode),
        contentId: "".concat(finnkode),
        name: 'n/a',
        category: getCategory(adType),
        hasExtendedProfile: true
      }]
    },
    target: {
      id: "".concat(finnkode),
      type: 'ClassifiedAd',
      name: 'n/a',
      contentId: "".concat(finnkode),
      category: getCategory(adType)
    }
  });
}

// RE_ev15 - Click on share ad, ad detail

function trackEventShareAd() {
  var adType = adminData.adType,
    finnkode = adminData.finnkode;
  pulse.trackEvent({
    type: 'Click',
    intent: 'Share',
    name: 'Share ad',
    object: {
      id: "".concat(finnkode),
      type: 'UIElement',
      elementType: 'Button',
      items: [{
        type: 'ClassifiedAd',
        id: "".concat(finnkode),
        contentId: "".concat(finnkode),
        name: 'n/a',
        category: getCategory(adType),
        hasExtendedProfile: true
      }]
    }
  });
}

// RE_ev16 - Click on edit ad, ad detail

function trackEventEditAd() {
  var adType = adminData.adType,
    finnkode = adminData.finnkode;
  pulse.trackEvent({
    type: 'Click',
    intent: 'Edit',
    name: 'Edit ad',
    object: {
      id: "".concat(finnkode),
      type: 'UIElement',
      elementType: 'Button',
      items: [{
        type: 'ClassifiedAd',
        id: "".concat(finnkode),
        contentId: "".concat(finnkode),
        name: 'n/a',
        category: getCategory(adType),
        hasExtendedProfile: true
      }]
    },
    target: {
      id: "".concat(finnkode),
      type: 'Form',
      name: 'n/a'
    }
  });
}

// RE_ev20 - Add "innholdsmodul"
// Can also be used for other ad sections

function trackEventEditAdSection(section) {
  var adType = adminData.adType,
    finnkode = adminData.finnkode;
  var sectionName = section.replace(/([A-Z])/g, ' $1').trim().toLowerCase();
  pulse.trackEvent({
    type: 'Click',
    intent: 'Edit',
    name: "Add ".concat(sectionName),
    object: {
      id: "".concat(finnkode),
      type: 'UIElement',
      elementType: 'Button',
      items: [{
        type: 'ClassifiedAd',
        id: "".concat(finnkode),
        contentId: "".concat(finnkode),
        name: 'n/a',
        category: getCategory(adType),
        hasExtendedProfile: true
      }]
    },
    target: {
      id: "".concat(finnkode),
      type: 'Form',
      name: 'n/a'
    }
  });
}

// RE_ev17 - Click on delete ad, ad detail

function trackEventDeleteAd() {
  var adType = adminData.adType,
    finnkode = adminData.finnkode;
  pulse.trackEvent({
    type: 'Click',
    intent: 'Delete',
    name: 'Delete ad',
    object: {
      id: "".concat(finnkode),
      type: 'UIElement',
      elementType: 'Button',
      items: [{
        type: 'ClassifiedAd',
        id: "".concat(finnkode),
        contentId: "".concat(finnkode),
        name: 'n/a',
        category: getCategory(adType),
        hasExtendedProfile: true
      }]
    }
  });
}

// RE_ev18 - Click on show statistics

function trackEventShowStats() {
  var adType = adminData.adType,
    finnkode = adminData.finnkode;
  pulse.trackEvent({
    type: 'Click',
    intent: 'Show',
    name: 'Show statistics',
    object: {
      id: "".concat(finnkode),
      type: 'UIElement',
      elementType: 'Button',
      items: [{
        type: 'ClassifiedAd',
        id: "".concat(finnkode),
        contentId: "".concat(finnkode),
        name: 'n/a',
        category: getCategory(adType),
        hasExtendedProfile: true
      }]
    },
    target: {
      id: "".concat(finnkode),
      type: 'Page',
      pageType: 'tool',
      name: 'Annonsestatistikk'
    }
  });
}

// RE_ev19 - Download lead

function trackEventDownloadLeads() {
  var adType = adminData.adType,
    finnkode = adminData.finnkode;
  pulse.trackEvent({
    type: 'Click',
    intent: 'Download',
    name: 'Download leads',
    object: {
      id: "".concat(finnkode),
      type: 'UIElement',
      elementType: 'Button',
      items: [{
        type: 'ClassifiedAd',
        id: "".concat(finnkode),
        contentId: "".concat(finnkode),
        name: 'n/a',
        category: getCategory(adType),
        hasExtendedProfile: true
      }]
    },
    target: {
      id: "".concat(finnkode),
      type: 'ExternalContent',
      name: 'xlsx'
    }
  });
}

// RE_ev21 - Click on publish ad in form

function trackEventPublish() {
  var adType = adminData.adType,
    finnkode = adminData.finnkode;
  pulse.trackEvent({
    type: 'Click',
    intent: 'Create',
    name: 'Ad insertion - new building ad',
    object: {
      id: "".concat(finnkode),
      type: 'UIElement',
      elementType: 'Button',
      items: [{
        type: 'ClassifiedAd',
        id: "".concat(finnkode),
        contentId: "".concat(finnkode),
        name: 'n/a',
        category: getCategory(adType),
        hasExtendedProfile: true
      }]
    },
    target: {
      id: "".concat(finnkode),
      type: 'ClassifiedAd',
      name: "".concat(finnkode),
      category: "".concat(finnkode)
    }
  });
}

// RE_ev26 - Stop payment

function trackEventStopPayment() {
  var adType = adminData.adType,
    finnkode = adminData.finnkode;
  pulse.trackEvent({
    type: 'Click',
    intent: 'Stop',
    name: 'Stop payment',
    object: {
      id: "".concat(finnkode),
      type: 'UIElement',
      elementType: 'Button',
      items: [{
        type: 'ClassifiedAd',
        id: "".concat(finnkode),
        contentId: "".concat(finnkode),
        name: 'n/a',
        category: getCategory(adType),
        hasExtendedProfile: true
      }]
    }
  });
}

// RE_ev27 - Renew ad

function trackEventRenewAd() {
  var adType = adminData.adType,
    finnkode = adminData.finnkode;
  pulse.trackEvent({
    type: 'Click',
    intent: 'Renew',
    name: 'Renew ad',
    object: {
      id: "".concat(finnkode),
      type: 'UIElement',
      elementType: 'Button',
      items: [{
        type: 'ClassifiedAd',
        id: "".concat(finnkode),
        contentId: "".concat(finnkode),
        name: 'n/a',
        category: getCategory(adType),
        hasExtendedProfile: true
      }]
    }
  });
}

// RE_ev28 - Activate selected unit

function trackEventActivateUnit() {
  var adType = adminData.adType,
    finnkode = adminData.finnkode;
  pulse.trackEvent({
    type: 'Click',
    intent: 'Edit',
    name: 'Activate selected unit',
    object: {
      id: "".concat(finnkode),
      type: 'UIElement',
      elementType: 'Button',
      items: [{
        type: 'ClassifiedAd',
        id: "".concat(finnkode),
        contentId: "".concat(finnkode),
        name: 'n/a',
        category: getCategory(adType),
        hasExtendedProfile: true
      }]
    }
  });
}

// RE_ev22 - Preview ad in form

function trackEventPreview() {
  var adType = adminData.adType,
    finnkode = adminData.finnkode;
  pulse.trackEvent({
    type: 'Click',
    intent: 'Show',
    name: 'Preview ad',
    object: {
      id: "".concat(finnkode),
      type: 'UIElement',
      elementType: 'Button',
      items: [{
        type: 'ClassifiedAd',
        id: "".concat(finnkode),
        contentId: "".concat(finnkode),
        name: 'n/a',
        category: getCategory(adType),
        hasExtendedProfile: true
      }]
    },
    target: {
      id: "".concat(finnkode),
      name: 'n/a',
      contentId: "".concat(finnkode),
      category: getCategory(adType)
    }
  });
}

// RE_ev23 - Save unit

function trackEventSaveUnit() {
  var adType = adminData.adType,
    finnkode = adminData.finnkode;
  pulse.trackEvent({
    type: 'Click',
    intent: 'Save',
    name: 'Save unit',
    object: {
      id: "".concat(finnkode),
      type: 'UIElement',
      elementType: 'Button',
      items: [{
        type: 'ClassifiedAd',
        id: "".concat(finnkode),
        contentId: "".concat(finnkode),
        name: 'n/a',
        category: getCategory(adType),
        hasExtendedProfile: true
      }]
    }
  });
}

// RE_ev24 - Save draft

function trackEventSaveDraft() {
  var adType = adminData.adType,
    finnkode = adminData.finnkode;
  pulse.trackEvent({
    type: 'Click',
    intent: 'Save',
    name: 'Save draft',
    object: {
      id: "".concat(finnkode),
      type: 'UIElement',
      elementType: 'Button',
      items: [{
        type: 'ClassifiedAd',
        id: "".concat(finnkode),
        contentId: "".concat(finnkode),
        name: 'n/a',
        category: getCategory(adType),
        hasExtendedProfile: true
      }]
    }
  });
}

// RE_ev25 - Update ad

function trackEventUpdateAd() {
  var adType = adminData.adType,
    finnkode = adminData.finnkode;
  pulse.trackEvent({
    type: 'Click',
    intent: 'Update',
    name: 'Update ad',
    object: {
      id: "".concat(finnkode),
      type: 'UIElement',
      elementType: 'Button',
      items: [{
        type: 'ClassifiedAd',
        id: "".concat(finnkode),
        contentId: "".concat(finnkode),
        name: 'n/a',
        category: getCategory(adType),
        hasExtendedProfile: true
      }]
    }
  });
}

// CE_ev06 - Click in image carousel on ads

function trackEventImageGalleryNext(imagePath) {
  var projectName = adData.projectName,
    adType = adData.adType,
    finnkode = adData.finnkode;
  pulse.trackEvent({
    type: 'Click',
    intent: 'View',
    name: 'View carousel image',
    object: {
      id: imagePath,
      type: 'UIElement',
      elementType: 'Image',
      page: {
        type: 'ClassifiedAd'
      },
      items: [{
        type: 'ClassifiedAd',
        id: "".concat(finnkode),
        contentId: "".concat(finnkode),
        name: projectName,
        category: getCategory(adType),
        hasExtendedProfile: true
      }]
    },
    target: {
      id: imagePath,
      type: 'UIElement',
      elementType: 'Image',
      name: 'Carousel'
    }
  });
}

// CE_ev07 - View image in gallery on ads

function trackEventImageGalleryFullscreen(imagePath) {
  var projectName = adData.projectName,
    adType = adData.adType,
    finnkode = adData.finnkode;
  pulse.trackEvent({
    type: 'Click',
    intent: 'Open',
    name: 'Open image gallery',
    object: {
      id: imagePath,
      type: 'UIElement',
      elementType: 'Image',
      page: {
        type: 'ClassifiedAd'
      },
      items: [{
        type: 'ClassifiedAd',
        id: "".concat(finnkode),
        contentId: "".concat(finnkode),
        name: projectName,
        category: getCategory(adType),
        hasExtendedProfile: true
      }]
    },
    target: {
      id: imagePath,
      type: 'UIElement',
      elementType: 'Image',
      name: 'Gallery'
    }
  });
}

// CE_ev08 - Click on share object in email
// CE_ev09 - Click on share object on facebook
// CE_ev10 - Click on share object on Twitter

function trackClickOnShareAd(elementType) {
  var projectName = adData.projectName,
    adType = adData.adType,
    finnkode = adData.finnkode;
  pulse.trackEvent({
    type: 'Click',
    intent: 'Share',
    name: 'Share ad',
    object: {
      id: "".concat(finnkode),
      type: 'UIElement',
      elementType: elementType,
      items: [{
        type: 'ClassifiedAd',
        id: "".concat(finnkode),
        contentId: "".concat(finnkode),
        name: projectName,
        category: getCategory(adType),
        hasExtendedProfile: true
      }]
    }
  });
}

// CE_ev19 - Click on call (web) on object pages

function trackClickOnCallContact(position) {
  var projectName = adData.projectName,
    adType = adData.adType,
    finnkode = adData.finnkode,
    master = adData.master,
    brokers = adData.brokers,
    contactName = adData.contactName;
  var provider;
  if (master && master.brokers) {
    provider = master.brokers[0].contactName;
  } else if (brokers) {
    provider = brokers[0].contactName;
  } else {
    provider = contactName;
  }
  pulse.trackEvent({
    type: 'Click',
    intent: 'Call',
    name: 'Contact seller',
    object: {
      id: "".concat(finnkode),
      type: 'UIElement',
      elementTyp: 'Phone number',
      position: position,
      items: [{
        type: 'ClassifiedAd',
        id: "".concat(finnkode),
        contentId: "".concat(finnkode),
        name: projectName,
        category: getCategory(adType),
        hasExtendedProfile: true
      }]
    },
    target: {
      type: 'ExternalContent',
      name: 'Phone',
      referralCommission: false,
      provider: provider
    }
  });
}

// RE_ev08 - Inview -  nabolagsprofil
// RE_ev09 - Scroll/klikk i nabolagsprofil

function trackEventNeighbourhoodProfile(type, position) {
  var finnkode = adData.finnkode,
    projectName = adData.projectName,
    adType = adData.adType,
    master = adData.master;
  pulse.trackEvent({
    type: type === 'scroll' ? 'Click' : 'View',
    intent: 'Show',
    name: 'Neighbourhood widget',
    object: {
      id: "".concat(finnkode),
      type: 'UIElement',
      elementType: 'Widget',
      position: position || '',
      items: [{
        type: 'ClassifiedAd',
        id: "".concat(finnkode),
        contentId: "".concat(finnkode),
        name: projectName || master.projectName,
        category: getCategory(adType),
        hasExtendedProfile: true
      }]
    }
  });
}

// M_ev01 - Send message start

function trackSendMessage(messageId) {
  var finnkode = adData.finnkode,
    projectName = adData.projectName,
    adType = adData.adType,
    master = adData.master;
  pulse.trackEvent({
    type: 'Click',
    intent: 'Create',
    name: 'Send message',
    object: {
      id: "".concat(finnkode),
      type: 'UIElement',
      elementType: 'Button',
      items: [{
        type: 'ClassifiedAd',
        id: "".concat(finnkode),
        contentId: "".concat(finnkode),
        name: projectName || master.projectName,
        category: getCategory(adType),
        hasExtendedProfile: true
      }]
    },
    target: {
      id: messageId,
      type: 'Message'
    }
  });
}

/* 
    EVENT COLLECTOR
    Collects events for statistics and effect documentation 
*/

function eventCollectorPageViewsObjectPage(createdBy) {
  eventCollector.trackEvent({
    ecType: 'AD',
    ecCategory: 'NoOfPageViews_Main',
    eventData: {
      'ad.ownerid': createdBy
    }
  });
}
function eventCollectorObjectInterest(flag) {
  eventCollector.trackEvent({
    ecType: 'AD',
    ecCategory: "nybygg_interest_".concat(flag),
    analyticsName: 'contact.show-interest',
    eventFlags: flag
  });
}
function eventCollectorProjectUrlClick() {
  eventCollector.trackEvent({
    ecType: 'AD',
    ecCategory: 'PROSPECT_VIEW_CLICK',
    analyticsName: ACTION_CLICK_PROJECT_URL
  });
}
function eventCollectorProspectUrlClick() {
  eventCollector.trackEvent({
    ecType: 'AD',
    ecCategory: 'PROSPECT_ORDERED_CLICK',
    analyticsName: ACTION_CLICK_PROSPECTUS_URL
  });
}
/* 
    SUPPORT METHODS
*/

function getAdTypeTrackingId(adType) {
  if (adType === AD_TYPE_KFS) return TRACKING_ID_KFS;
  if (adType === AD_TYPE_PTS || adType === AD_TYPE_PTS_UNIT) return TRACKING_ID_PTS;
  if (adType === AD_TYPE_ETS) return TRACKING_ID_ETS;
  return null;
}
function getCategory(adType) {
  if (getAdTypeTrackingId(adType)) return "realestate > ".concat(getAdTypeTrackingId(adType));
  return 'n/a';
}
module.exports = {
  trackPageViewObject: trackPageViewObject,
  trackPageViewAdminIndex: trackPageViewAdminIndex,
  trackPageViewAdminAdDetail: trackPageViewAdminAdDetail,
  trackPageViewAdminBuyMarketing: trackPageViewAdminBuyMarketing,
  trackPageViewAdminAdSelect: trackPageViewAdminAdSelect,
  trackPageViewAdminAdForm: trackPageViewAdminAdForm,
  trackPageViewAdminAdPurchase: trackPageViewAdminAdPurchase,
  trackPageViewAdminAdConfirmation: trackPageViewAdminAdConfirmation,
  trackPageViewAdminPriceOverview: trackPageViewAdminPriceOverview,
  trackPageViewAdminOrgProfile: trackPageViewAdminOrgProfile,
  trackEventSignupInterestOpen: trackEventSignupInterestOpen,
  trackEventSignupInterestSend: trackEventSignupInterestSend,
  trackEventBuyBlinkFromMarketingOpen: trackEventBuyBlinkFromMarketingOpen,
  trackEventBuyBlinkFromMarketingSend: trackEventBuyBlinkFromMarketingSend,
  trackEventViewAd: trackEventViewAd,
  trackEventShareAd: trackEventShareAd,
  trackEventEditAd: trackEventEditAd,
  trackEventDeleteAd: trackEventDeleteAd,
  trackEventShowStats: trackEventShowStats,
  trackEventDownloadLeads: trackEventDownloadLeads,
  trackEventPublish: trackEventPublish,
  trackEventPreview: trackEventPreview,
  trackEventSaveUnit: trackEventSaveUnit,
  trackEventSaveDraft: trackEventSaveDraft,
  trackEventUpdateAd: trackEventUpdateAd,
  trackEventImageGalleryNext: trackEventImageGalleryNext,
  trackEventImageGalleryFullscreen: trackEventImageGalleryFullscreen,
  trackEventEditAdSection: trackEventEditAdSection,
  trackEventViewCustomerContent: trackEventViewCustomerContent,
  trackEventOrderProspect: trackEventOrderProspect,
  trackEventStopPayment: trackEventStopPayment,
  trackEventRenewAd: trackEventRenewAd,
  trackEventActivateUnit: trackEventActivateUnit,
  trackEventNeighbourhoodProfile: trackEventNeighbourhoodProfile,
  trackSendMessage: trackSendMessage,
  eventCollectorPageViewsObjectPage: eventCollectorPageViewsObjectPage,
  eventCollectorObjectInterest: eventCollectorObjectInterest,
  eventCollectorProjectUrlClick: eventCollectorProjectUrlClick,
  eventCollectorProspectUrlClick: eventCollectorProspectUrlClick,
  trackRegisterForViewing: trackRegisterForViewing,
  trackClickOnLinksInUsefulLinks: trackClickOnLinksInUsefulLinks,
  trackGoToHomepage: trackGoToHomepage,
  trackPhoneNumberUserInterest: trackPhoneNumberUserInterest,
  trackClickOnShareAd: trackClickOnShareAd,
  trackClickOnCallContact: trackClickOnCallContact,
  trackClickOnExtendedProfileCta: trackClickOnExtendedProfileCta,
  trackClickOnExtendedProfileLink: trackClickOnExtendedProfileLink,
  trackClickOnVirtualViewingUrl: trackClickOnVirtualViewingUrl,
  trackClickOnVideoViewingUrl: trackClickOnVideoViewingUrl
};